import styled from 'styled-components/macro';
import { colorAccentError700, colorCoreBlack300, colorCoreBlack900Base, colorCoreWhite1000, } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { HeadingLevel3, RegularTextLevel3 } from '@yme/tokens/typography';
export const InfoBlockContainerStyled = styled(FlexWrapper) `
  ${({ isSuccess }) => `
    border-top: 6px solid ${isSuccess ? colorCoreBlack900Base : colorAccentError700};
  `}

  background-color: ${colorCoreWhite1000};
`;
export const HeaderStyled = styled.div `
  margin-bottom: 24px;

  ${ADAPTIVE.minWidth.desktop} {
    margin-bottom: 32px;
  }
`;
export const DescriptionLabelStyled = styled(RegularTextLevel3) `
  margin-top: 8px;
  color: ${colorCoreBlack300};
`;
export const TitleContainerStyled = styled(HeadingLevel3) `
  display: flex;
  align-items: center;
  font-size: 24px;
`;
export const TitleLabelStyled = styled.span `
  margin-right: 14px;
`;
export const ButtonsContainerStyled = styled(FlexWrapper) `
  width: 100%;
`;
